<template>
  <div class="row mt-4">
    <div class="col-7 text-uppercase mb-4">
      <h4><b>Conversas do WhatsApp</b></h4>
    </div>

    <div v-if="tokens.length" class="row w-100">
      <div class="col-md-4 token-panel-list">
        <div class="card shadow-sm p-2">
          <div v-for="token in tokens" :key="token.id">
            <div class="card mb-3">
              <div
                class="card-header d-flex justify-content-between"
                :class="
                  token.status ? 'bg-success-lighten-4' : 'bg-error-lighten-4'
                "
                @click="toggleToken(token.id)"
                style="cursor: pointer"
              >
                <span>{{ token.construp_user_id }}</span>
                <span
                  ><b>{{ formatPhone(token.whatsapp) }}</b></span
                >
              </div>

              <div v-show="expandedTokens.includes(token.id)">
                <div class="card-body p-2">
                  <div
                    v-for="client in token.ia_clients"
                    :key="client.id"
                    class="client-chat"
                    @click="getChat(client)"
                  >
                    <p>
                      <b>{{ client.name }}</b>
                    </p>
                    <p>{{ formatPhone(client.number) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="client-info" v-if="selectedClient">
          <p><span class="label">Nome:</span> {{ selectedClient.name }}</p>
          <p>
            <span class="label">Número:</span>
            {{ formatPhone(selectedClient.number) }}
          </p>
        </div>
        <div class="chat-container" ref="chatContainer">
          <div
            v-for="(msg, index) in messages"
            :key="index"
            class="chat-messages"
          >
            <div class="bot-msg">
              <p class="message-content">{{ msg.bot_message }}</p>
            </div>
            <div class="user-msg">
              <p class="message-content">{{ msg.user_message }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="col-12 text-center mt-4">
      <p>Nenhuma mensagem encontrada.</p>
    </div>
  </div>
</template>

<script>
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'ConversasWhatsapp',
  mixins: [makeToast],
  data() {
    return {
      tokens: [],
      messages: [],
      selectedClient: null,
      expandedTokens: [],
    };
  },
  methods: {
    async getChats() {
      try {
        const { data } = await shopkeeperAppApi.get(`/chats/86400`);
        this.tokens = data;
      } catch (error) {
        this.toastError('Erro ao carregar chats');
        console.error(error);
      }
    },
    async getChat(client) {
      try {
        this.selectedClient = client;
        const lastChat = client.chats[client.chats.length - 1];
        const { data } = await shopkeeperAppApi.get(`/messages/${lastChat.id}`);
        this.messages = data;
        this.$nextTick(() => {
          const container = this.$refs.chatContainer;
          if (container) container.scrollTop = container.scrollHeight;
        });
      } catch (error) {
        this.toastError('Erro ao carregar mensagens');
        console.error(error);
      }
    },
    toggleToken(tokenId) {
      const index = this.expandedTokens.indexOf(tokenId);
      if (index === -1) {
        this.expandedTokens.push(tokenId);
      } else {
        this.expandedTokens.splice(index, 1);
      }
    },
    formatPhone(value) {
      if (!value) return '';
      value = value.replace(/\D/g, '');
      value = value.replace(/(\d{2})(\d)/, '($1) $2');
      value = value.replace(/(\d)(\d{4})$/, '$1-$2');
      return value;
    },
  },
  mounted() {
    this.getChats();
  },
};
</script>

<style scoped>
.bg-success-lighten-4 {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.bg-error-lighten-4 {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.token-panel-list {
  max-height: 610px;
  overflow-y: auto;
  padding-right: 6px;
}

.token-panel-list::-webkit-scrollbar {
  width: 6px;
}

.token-panel-list::-webkit-scrollbar-track {
  background: transparent;
}

.token-panel-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.chat-container::-webkit-scrollbar {
  width: 6px;
}

.chat-container::-webkit-scrollbar-track {
  background: transparent;
}

.chat-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.token-panel-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.client-chat {
  padding: 10px;
  border-radius: 5px;
  background-color: #f1f1f1;
  margin-bottom: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.client-info {
  background-color: #e9f5ff;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 15px;
  line-height: 1.4;
}

.client-info .label {
  font-weight: bold;
  color: #0d6efd;
}

.chat-container {
  height: 520px;
  overflow-y: auto;
  display: flex;
  flex-direction: column-reverse;
  border: 1px solid #ccc;
  padding: 12px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-msg {
  align-self: flex-end;
  background-color: #dcf8c6;
  color: #000;
  padding: 10px 14px;
  border-radius: 14px 14px 0 14px;
  max-width: 70%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.bot-msg {
  align-self: flex-start;
  background-color: #ffffff;
  color: #000;
  padding: 10px 14px;
  border-radius: 14px 14px 14px 0;
  max-width: 70%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.message-content {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
